<template>
  <b-modal
      id="renewalPlanSwitchModal"
      modal-class="plan-renewable-modal"
      centered
      size="lg"
      hide-footer
      hide-header-close
      @shown="getCurrentPlan"
  >
    <b-button variant="close-btn" class='btn-container' @click="closeModal">
      <i class="fas fa-times"></i>
    </b-button>
    <b-container fluid ref="memberDocContainer">
      <div class="view-clients-modal-content">
        <div class="col-xl-12">
          <div class="notice">
            <h2>Open Enrollment Plan Change Eligible</h2>
            <p class="mb-3">
              Your plan is eligible to change for Jan 1, 2026, you can keep your existing plan or choose
              to change to another plan. Deadline to change is 12/15/2025. If you do
              not choose a new plan, your current plan will renew at the renewal rate.
            </p>
            <ul class="text-center mt-2" v-if="loadingPlan">
              <strong>Loading...</strong>
            </ul>
            <ul v-else>
              <dashboard-enrollment-current-plan :current-plan.sync="currentPlan"  />
              <dashboard-enrollment-renewal-plan :current-plan.sync="currentPlan" :member="member"/>
            </ul>
          </div>
        </div>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import Api from "@/resource/ApiV2"
import DashboardEnrollmentCurrentPlan from "../DashboardEnrollment/DashboardEnrollmentCurrentPlan";
import DashboardEnrollmentRenewPlan from "../DashboardEnrollment/DashboardEnrollmentRenewPlan";

export default {
  name: "planRenewalSwitchModal",
  props: {
    member: {
      required: true,
    },
  },
  data: () => ({
    currentPlan: false,
    loadingPlan: false
  }),
  methods: {
    /*    getCurrentNewPlan(){
          this.getCurrentPlan()
          this.$emit("onSwitchedPlanGetProducts")
        },*/
    getCurrentPlan() {
      console.log('getCurrentPlan1')
      this.loadingPlan = true
      const url = `get-current-major-medical-plan/${this.member.user_id}`;
      Api.get(url)
          .then((res) => {
            this.currentPlan = res.data.data;
            this.loadingPlan = false
          })
          .catch(() => {
            this.currentPlan = null;
            this.loadingPlan = false
          }).finally(() => {
        this.loadingPlan = false
      });

    },
    closeModal() {
      this.$bvModal.hide('renewalPlanSwitchModal')
    }
  },
  components: {
    'dashboard-enrollment-current-plan': DashboardEnrollmentCurrentPlan,
    'dashboard-enrollment-renewal-plan': DashboardEnrollmentRenewPlan
  }
}
</script>

<style src='@/assets/css/group_dashboard/plan-renewal.css'>
</style>